import React, { useRef, useState } from "react";
import { Form, Field } from "react-final-form";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { classNames } from "primereact/utils";
import { Toast } from "primereact/toast";
import { instance } from "../../api";
import { useUser } from "../../Context/UserContext";
import FileUploader from '../NousContacter/FileUploader.jsx'
import "../NousContacter/FileUploader.css"
export default function NousContacter({ setDialog }) {
  const { user } = useUser();
  const [file, setFile] = useState(null);
 
  
  const toast = useRef(null);
  const onSubmit = async (data) => {
    
    const utilisateurId = user.id_utilisateur_gexonline;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("message", data.message);
    formData.append("objet", data.objet);

    try {

         await instance.post(`/api/utilisateurs/${utilisateurId}/formulaire/contact`, formData)
       .then(()=>{

        toast.current.show({ severity: 'success', summary: 'succès ', detail: 'Votre demande a été envoyé avec succès  ', life: 1000 });
        //  setDialog(false)
       })

        setTimeout(() => {
            setDialog(false)
          }, 1000);
    }

    catch (error) {

        console.error(error);

    }
  };
  const validate = (data) => {
    let errors = {};

    if (!data.objet) {
      errors.objet = "Ce champ est obligatoire.";
    }
    if (!data.message) {
      errors.message = "Ce champ est obligatoire.";
    }

    return errors;
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return (
      isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>
    );
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="toolBar_header">
        <Form
          onSubmit={onSubmit}
          initialValues={{ objet: "", message: "", file: "" }}
          validate={validate}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit} className="p-fluid">
              <Field
                name="objet"
                render={({ input, meta }) => (
                  <div className="p-field">
                    <span className="p-float-label p-input-icon-right">
                      <InputText
                        id="objet"
                        {...input}
                        className={classNames({
                          "p-invalid": isFormFieldValid(meta),
                        })}
                      />
                      <label
                        htmlFor="objet"
                        className={classNames({
                          "p-error": isFormFieldValid(meta),
                        })}
                      >
                        Objet *
                      </label>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}
              />
              <Field
                name="message"
                render={({ input, meta }) => (
                  <div className="p-field">
                    <span className="p-float-label p-input-icon-right">
                      <InputTextarea
                        id="message"
                        {...input}
                        className={classNames({
                          "p-invalid": isFormFieldValid(meta),
                        })}
                        autoResize
                      />
                      <label
                        htmlFor="message"
                        className={classNames({
                          "p-error": isFormFieldValid(meta),
                        })}
                      >
                        Écrivez ici *
                      </label>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}
              />
               <FileUploader
                onFileChange={(selectedFile) => setFile(selectedFile)}
                label="Joindre un fichier"
                maxSize={20} // 20 MB
              />
              <div className="btnContact">
                <Button type="submit" label="Envoyer" className="p-mt-2 send" />
              </div>
            </form>
          )}
        />
      </div>
    </>
  );
}
